import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";
import { IHostedCompetitionDTO } from "../../../../../../api-services/football/admin/manage-football-team-service";

export interface IHostedCompetitionEditOption {
  teamId: number;
  hostedCompetitionId: number;
  hostedCompetitionData: IHostedCompetitionDTO;
}

interface IHostedCompetitionEditState {
  hostedCompetitionEditResponseStatus: StatusEnum;
}

const initialState: IHostedCompetitionEditState = {
  hostedCompetitionEditResponseStatus: StatusEnum.Idle,
};

export const hostedCompetitionEdit = createAsyncThunk(
  "manage/hostedCompetitionEdit",
  async (options: IHostedCompetitionEditOption, thunkAPI) => {
    try {
      const hostedCompetitionEditResponse = await manageFootballTeamService.editHostedCompetition(
        options.teamId,
        options.hostedCompetitionId,
        options.hostedCompetitionData
      );
      return hostedCompetitionEditResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageHostedCompetitionEditSlice = createSlice({
  name: "hostedCompetitionEdit",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(hostedCompetitionEdit.pending, (state) => {
        state.hostedCompetitionEditResponseStatus = StatusEnum.Loading;
      })
      .addCase(hostedCompetitionEdit.fulfilled, (state) => {
        state.hostedCompetitionEditResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(hostedCompetitionEdit.rejected, (state) => {
        state.hostedCompetitionEditResponseStatus = StatusEnum.Failed;
      });
  },
});

export default manageHostedCompetitionEditSlice.reducer;
